import React, { createContext, ReactNode, useState } from 'react';

export interface IDropdownContext {
  isActive: boolean;
  isSelected: boolean;
  setIsSelected: (isSelected: boolean) => void;
  closeDropdown: () => void;
  toggleDropdown: () => void;
}

export const DropdownContext = createContext<IDropdownContext | Record<string, unknown>>({});

interface Props {
  children: ReactNode;
}

export default function DropdownContextProvider({ children }: Props) {
  const [isActive, setIsActive] = useState<IDropdownContext['isActive']>(false);
  const [isSelected, setIsSelected] = useState<IDropdownContext['isSelected']>(false);
  const closeDropdown: IDropdownContext['closeDropdown'] = () => setIsActive(false);
  const toggleDropdown: IDropdownContext['toggleDropdown'] = () => setIsActive(isActive => !isActive);

  return (
    <DropdownContext.Provider value={{ isActive, isSelected, closeDropdown, toggleDropdown, setIsSelected }}>
      {children}
    </DropdownContext.Provider>
  );
}
